import { defineComponent as d, openBlock as a, createElementBlock as o, mergeProps as p, unref as e, renderSlot as i, createElementVNode as V, createCommentVNode as u } from "vue";
import { useScalarIcon as M } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, g = { key: 1 }, m = { key: 2 }, A = { key: 3 }, f = { key: 4 }, k = { key: 5 }, h = {
  name: "ScalarIconLockSimple"
}, _ = /* @__PURE__ */ d({
  ...h,
  props: {
    label: {},
    weight: {}
  },
  setup(n) {
    const H = n, { bind: r, weight: l } = M(H);
    return (s, t) => (a(), o("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(r)), [
      i(s.$slots, "default"),
      e(l) === "bold" ? (a(), o("g", Z, t[0] || (t[0] = [
        V("path", { d: "M208,76H180V56A52,52,0,0,0,76,56V76H48A20,20,0,0,0,28,96V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V96A20,20,0,0,0,208,76ZM100,56a28,28,0,0,1,56,0V76H100ZM204,204H52V100H204Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (a(), o("g", g, t[1] || (t[1] = [
        V("path", {
          d: "M216,96V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H208A8,8,0,0,1,216,96Z",
          opacity: "0.2"
        }, null, -1),
        V("path", { d: "M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Z" }, null, -1)
      ]))) : e(l) === "fill" ? (a(), o("g", m, t[2] || (t[2] = [
        V("path", { d: "M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96Z" }, null, -1)
      ]))) : e(l) === "light" ? (a(), o("g", A, t[3] || (t[3] = [
        V("path", { d: "M208,82H174V56a46,46,0,0,0-92,0V82H48A14,14,0,0,0,34,96V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V96A14,14,0,0,0,208,82ZM94,56a34,34,0,0,1,68,0V82H94ZM210,208a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V96a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Z" }, null, -1)
      ]))) : e(l) === "regular" ? (a(), o("g", f, t[4] || (t[4] = [
        V("path", { d: "M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Z" }, null, -1)
      ]))) : e(l) === "thin" ? (a(), o("g", k, t[5] || (t[5] = [
        V("path", { d: "M208,84H172V56a44,44,0,0,0-88,0V84H48A12,12,0,0,0,36,96V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V96A12,12,0,0,0,208,84ZM92,56a36,36,0,0,1,72,0V84H92ZM212,208a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V96a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  _ as default
};
